(function (angular) {
	angular.module('bizPartEngage').directive('bizCookieSettings', bizCookieSettingsDirective);

	bizCookieSettingsDirective.$inject = ["bizCore"];

	function bizCookieSettingsDirective(bizCoreProvider) {
		var directive = {
			restrict: "E",
			scope: {

			},
			templateUrl: function (element, attr) {
				if (attr.templateurl) {
					return siteRootPath + attr.templateurl;
				}
				else {
					return bizCoreProvider.getView('core.directives.cookiesettings', "FrontEnd/Core/Directives/Views/CookieSettings.html");
				}
			},
			bindToController: true,
			controller: bizCookieSettingsController,
			controllerAs: "vm"
		};

		bizCookieSettingsController.$inject = ["$rootScope", "bizCoreService"];

		function bizCookieSettingsController($rootScope, bizCoreService) {
			var vm = this;

			//vm.Cookies = [{
			//	Name: "Bizpart",
			//	Value: "",
			//	Group: "Functional",
			//	Mandatory: true
			//}, {
			//	Name: "Google",
			//	Value: "",
			//	Group: "Tracking",
			//	Mandatory: false
			//}
			//];

			vm.ToggleCookie = ToggleCookie;

			function ToggleCookie(item) {
				$rootScope.HasAcceptedCookies = !$rootScope.HasAcceptedCookies;
				setLocalStorage("HasAcceptedCookies", $rootScope.HasAcceptedCookies);

				if ($rootScope.IsLoggedIn) {
					bizCoreService.UpdateUserSetting("HasAcceptedCookies", $rootScope.HasAcceptedCookies).then(function (response) {

					});
				}
            }

            function Init() {
            }

			vm.$onInit = function () {
				Init();
			}
		}

		return directive;
	}
})(window.angular);
